import axios from "axios";
import {LINK} from "../../utils/Links";

export class HomePageApi {

    static getHomePageData = async (token: string) => {
        try {
            const result = await axios.get(LINK.HOME, {
                params: {
                    token
                }
            });
            return result.data;
        } catch (e) {
            throw e;
        }
    };

    static logout = async (token: string, url: string) => {
        try {
            const result = await axios.post(LINK.LOGOUT, {token, url});
            return result.data;
        } catch (e) {
            throw e;
        }
    };
}